import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchFormData, fetchData } from "../../utils/options";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";
import { BaseUrl } from "../..";
import TextArea from "../shared/TextArea";
const ContentCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [courseOptions, setCourseOptions] = useState([]);
  const [semesterOptions, setSemesterOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [topicOptions, setTopicOptions] = useState([]);
  const [chapterOptions, setChapterOptions] = useState([]);
  const [contentDetails, setContentDetails] = useState([
    { id: 1, image_type: "", contain: "", image_file: "" },
  ]);

  const [notesDetails, setNotesDetails] = useState([
    { id: 1, describe: "", file: null },
  ]);

  const [pdfDetails, setPdfDetails] = useState([
    { id: 1, describe: "", file: null ,text:""},
  ]);

  const [videoDetails, setVideoDetails] = useState([
    { id: 1, text: "", file: null, youtube_url: "", is_youtube: 0 },
  ]);

  const [activeTab, setActiveTab] = useState("notes");

  const [formData, setFormData] = useState({
    title: "",
    course_id: "",
    semester_id: "",
    subject_id: "",
    chapter_id: "",
    topic_id: "",
    description: "",
    status: "1",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) navigate("/");
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));

    // When course changes
    if (key === "course_id") {
      setSemesterOptions([]);
      setSubjectOptions([]);
      setChapterOptions([]);
      setTopicOptions([]);
      setFormData((p) => ({
        ...p,
        semester_id: "",
        subject_id: "",
        chapter_id: "",
        topic_id: "",
      }));
      fetchSemesters(value);
    }

    // When semester changes
    if (key === "semester_id") {
      setSubjectOptions([]);
      setChapterOptions([]);
      setTopicOptions([]);
      setFormData((p) => ({
        ...p,
        subject_id: "",
        chapter_id: "",
        topic_id: "",
      }));
      fetchSubjects(value);
    }

    // When subject changes
    if (key === "subject_id") {
      setChapterOptions([]);
      setTopicOptions([]);
      setFormData((p) => ({
        ...p,
        chapter_id: "",
        topic_id: "",
      }));
      fetchChapters(value);
    }

    // When chapter changes
    if (key === "chapter_id") {
      setTopicOptions([]);
      setFormData((p) => ({
        ...p,
        topic_id: "",
      }));
      fetchTopics(value);
    }
  };
  const handleOnChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  console.log(handleOnChange);

  // Load Courses
  const fetchCourses = async () => {
    try {
      const result = await fetchData("course-dropdown", {}, "POST");
      if (result?.success) {
        const data = result.data || [];
        setCourseOptions(
          data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load courses:", error);
    }
  };

  // Load Semesters by Course
  const fetchSemesters = async (course_id) => {
    if (!course_id) return;

    const form = new FormData();
    form.append("course_id", course_id);

    try {
      const result = await fetchFormData("semester-dropdown", form, "POST");
      if (result?.success) {
        const data = result.data || [];
        setSemesterOptions(
          data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load semesters:", error);
    }
  };

  // Load Subjects by Semester
  const fetchSubjects = async (semester_id) => {
    if (!semester_id) return;

    const form = new FormData();
    form.append("semester_id", semester_id);

    try {
      const result = await fetchFormData("subject-dropdown", form, "POST");
      if (result?.success) {
        const data = result.data || [];
        setSubjectOptions(
          data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load subjects:", error);
    }
  };

  const fetchChapters = async (subject_id) => {
    if (!subject_id) return;

    const form = new FormData();
    form.append("subject_id", subject_id);

    const result = await fetchFormData("chapter-dropdown", form, "POST");
    if (result?.success) {
      const data = result.data || [];
      setChapterOptions(
        data.map((item) => ({ label: item.title, value: item.id }))
      );
    }
  };

  const fetchTopics = async (chapter_id) => {
    if (!chapter_id) return;

    const form = new FormData();
    form.append("chapter_id", chapter_id);

    const result = await fetchFormData("topic-dropdown", form, "POST");
    if (result?.success || result?.code === 200) {
      const data = result.data || [];
      setTopicOptions(
        data.map((item) => ({ label: item.title, value: item.id }))
      );
    }
  };

  // remove api
  const removeThumnail = async (content_id) => {
    if (!content_id) return;

    const form = new FormData();
    form.append("content_id", content_id);

    const result = await fetchFormData(
      "content/remove-thumbnail",
      form,
      "POST"
    );
    if (result?.success || result?.code === 200) {
      topTost({
        title: result.result?.message || "Thumbnail removed successfully",
        icon: "success",
      });
      setFormData((prev) => ({
        ...prev,
        thumnail_image: null,
        thumbnail_preview: result.data?.thumbnail_image || null,
      }));
    }
  };
  const removeLocalThumnail = () => {
    setFormData((prev) => ({
      ...prev,
      thumnail_image: null,
      thumbnail_preview: null,
    }));
  };

  // Fetch Chapter Detail for Edit
  const fetchAllDetails = async (id) => {
    const result = await fetchData(`contentbyid/${id}`, {}, "POST");

    if (result?.success || result?.code === 200) {
      const d = result.data;

      // Fill main form fields
      setFormData((prev) => ({
        ...prev,
        id: d.id,
        title: d.title,
        course_id: d.course_id,
        semester_id: d.semester_id,
        subject_id: d.subject_id,
        chapter_id: d.chapter_id,
        topic_id: d.topic_id,
        description: d.description,
        status: d.status?.toString() || "1",
        thumnail_image: null, // no new file yet
        thumbnail_preview: d.thumbnail_url || "", // use URL from backend
      }));

      setNotesDetails(
        d.Notes?.length
          ? d.Notes.map((item) => ({
              id: item.id,
              describe: item.text,
              file: null,
              preview: item.image_file || "",
            }))
          : [{ id: 1, describe: "", file: null, preview: "" }]
      );

      setPdfDetails(
        d.Pdf?.length
          ? d.Pdf.map((item) => ({
              id: item.id,
              file: null,
              describe:item.text || "",
              preview: item.pdf_file || "",
            }))
          : [{ id: 1, file: null, preview: "" }]
      );
      setVideoDetails(
        d.Video?.length
          ? d.Video.map((item) => ({
              id: item.id,
              describe: item.text || "",
              file: null,
              youtube_url: item.youtube_url || "",
              preview: item.video_file || "",
            }))
          : [{ id: 1, file: null, preview: "", youtube_url: "" }]
      );
      // Fetch dependent options without clearing values
      fetchSemesters(d.course_id);
      fetchSubjects(d.semester_id);
      fetchChapters(d.subject_id);
      fetchTopics(d.chapter_id);
    }
  };

  useEffect(() => {
    fetchCourses();
    if (id) fetchAllDetails(id);
  }, [id]);

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = {
      course_id: "Course",
      semester_id: "Semester",
      subject_id: "Subject",
      chapter_id: "Chapter",
      title: "Topic Title",
    };
    const missing = Object.entries(requiredFields).find(
      ([key]) => !formData[key]
    );
    if (missing) {
      topTost({ title: `Please select ${missing[1]}`, icon: "error" });
      return;
    }
    setIsSubmitting(true);

    // PDF validation: text entered but file missing
    const invalidPdf = pdfDetails.find(
      (item) => item.describe?.trim() && !item.file
    );

    if (invalidPdf) {
      topTost({
        title: "Please upload PDF file for entered PDF description",
        icon: "error",
      });
      setIsSubmitting(false);
      return;
    }
    const invalidVideo = videoDetails.find((item) => {
      const hasText = item.text?.trim() || item.describe?.trim();

      if (item.is_youtube === 1) {
        return hasText && !item.youtube_url?.trim();
      }

      return hasText && !item.file;
    });

    if (invalidVideo) {
      topTost({
        title:
          "Please add video file or YouTube url for entered video description",
        icon: "error",
      });
      setIsSubmitting(false);
      return;
    }

    try {
      const token = localStorage.getItem("access_token");

      // Convert file → Base64
      const fileToBase64 = (file) => {
        return new Promise((resolve) => {
          if (!file) return resolve(null);
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
        });
      };

      // Convert List Based on Required JSON Format
      const convertNotes = async (list) => {
        return await Promise.all(
          list.map(async (item) => ({
            text: item.describe,
            image: item.file ? await fileToBase64(item.file) : null,
          }))
        );
      };

      const convertPdf = async (list) => {
        return await Promise.all(
          list.map(async (item) => ({
            text:item.describe || "",
            pdf: item.file ? await fileToBase64(item.file) : null,
          }))
        );
      };

      const convertVideo = async (list) => {
        return await Promise.all(
          list.map(async (item) => {
            const text = item.text || item.describe || "";
            if (item.is_youtube === 1) {
              return {
                text: item.text || "",
                is_youtube: 1,
                youtube_url: item.youtube_url || "",
              };
            }

            return {
              text: item.text || "",
              is_youtube: 0,
              video: item.file ? await fileToBase64(item.file) : null,
            };
          })
        );
      };

      // Thumbnail
      const thumbnailBase64 = formData.thumnail_image
        ? await fileToBase64(formData.thumnail_image)
        : null;

      // Final Payload EXACTLY as API expects
      const payload = {
        course_id: Number(formData.course_id),
        semester_id: Number(formData.semester_id),
        subject_id: Number(formData.subject_id),
        chapter_id: Number(formData.chapter_id),
        title: formData.title,
        thumbnail: thumbnailBase64,
        description: formData.description || "",
        Notes: notesDetails.length ? await convertNotes(notesDetails) : [],
        Pdf: pdfDetails.length ? await convertPdf(pdfDetails) : [],
        Video: await convertVideo(videoDetails),
      };

      // Append to FormData properly

      const url = id
        ? `${BaseUrl}content/update/${id}`
        : `${BaseUrl}content/create`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (result?.result?.code === 200) {
        topTost({ title: result?.result?.message, icon: "success" });
        setTimeout(() => {
          navigate("/master/topic-list");
        }, 600);
      } else {
        topTost({
          title: result?.result?.message || "Error saving content",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit Error:", error);
      topTost({ title: "Something went wrong!", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                {id ? "Edit Topic:" : "Add Topic:"}
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="p-3 ">
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="course-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Course Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="course-select"
                    name="course_id"
                    value={formData.course_id || ""}
                    onSelectOption={(option) =>
                      handleChange("course_id", option?.value)
                    }
                    options={courseOptions}
                    placeholder="Select an option"
                    icon="fa-opera"
                    required
                  />
                </div>
              </div>
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="semester-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Semester Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="semester-select"
                    name="semester_id"
                    value={formData.semester_id || ""}
                    onSelectOption={(option) =>
                      handleChange("semester_id", option?.value)
                    }
                    options={semesterOptions}
                    placeholder="Select an option"
                    icon="feather-file-text"
                    required
                  />
                </div>
              </div>
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="subject-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Subject Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="subject-select"
                    name="subject_id"
                    value={formData.subject_id}
                    onSelectOption={(option) =>
                      handleChange("subject_id", option?.value)
                    }
                    options={subjectOptions}
                    placeholder="Select an option"
                    icon="feather-layers"
                    required
                  />
                </div>
              </div>
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="chapter-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Chapter Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="chapter-select"
                    name="chapter_id"
                    value={formData.chapter_id || ""}
                    onSelectOption={(option) =>
                      handleChange("chapter_id", option?.value)
                    }
                    options={chapterOptions}
                    placeholder="Select Chapter"
                    icon="feather-list"
                    required
                  />
                </div>
              </div>

              <Input
                label="Topic Title"
                name="title"
                placeholder="Enter Topic Title"
                value={formData.title || ""}
                onChange={handleOnChange}
                icon="feather-hash"
                required
              />
              <TextArea
                label="Description"
                placeholder="Enter Description"
                value={formData.description}
                onChange={(e) => handleChange("description", e.target.value)}
                icon="fa-briefcase"
              />
              <Input
                label="Thumnail Image"
                name="thumnail_image"
                // value={formData.thumnail_image}
                type="file"
                accept="image/*,application/pdf,video*/"
                onChange={(e) => {
                  const file = e.target.files[0] || null;
                  setFormData((prev) => ({
                    ...prev,
                    thumnail_image: file,
                    thumbnail_preview: file ? URL.createObjectURL(file) : null,
                  }));
                }}
                icon="feather-compass"
                required={!id}
              />
              {formData.thumbnail_preview && (
                <div className="row mb-4 align-items-center">
                  <label className="col-lg-2 fw-semibold">
                    Thumbnail Preview:
                  </label>

                  <div className="col-lg-6">
                    <img
                      src={formData.thumbnail_preview}
                      // alt="thumbnail_preview"
                      style={{
                        maxWidth: "200px",
                        maxHeight: "150px",
                        objectFit: "cover",
                        display: "block",
                        marginBottom: "10px",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        if (id) {
                          removeThumnail(id);
                        } else {
                          removeLocalThumnail();
                        }
                      }}
                    >
                      Remove
                    </button>{" "}
                  </div>
                </div>
              )}
              {!id && (
                <>
                  <div className="mb-3 d-flex justify-content-start">
                    <button
                      type="button" // <- add this
                      className={`btn ${
                        activeTab === "notes" ? "btn-primary" : "btn-light"
                      } me-2`}
                      onClick={() => setActiveTab("notes")}
                    >
                      Notes
                    </button>

                    <button
                      type="button" // <- add this
                      className={`btn ${
                        activeTab === "pdf" ? "btn-primary" : "btn-light"
                      } me-2`}
                      onClick={() => setActiveTab("pdf")}
                    >
                      PDF
                    </button>

                    <button
                      type="button" // <- add this
                      className={`btn ${
                        activeTab === "videos" ? "btn-primary" : "btn-light"
                      }`}
                      onClick={() => setActiveTab("videos")}
                    >
                      Videos
                    </button>
                  </div>

                  {/* Tab Content */}
                  <div className="mb-2">
                    {activeTab === "notes" && (
                      <>
                        <label className="pb-2">
                          <strong>Add Notes Details:</strong>
                        </label>
                        {notesDetails.map((item, index) => (
                          <div
                            key={item.id}
                            className="d-flex align-items-center mb-2"
                            style={{ gap: "8px" }}
                          >
                            <textarea
                              placeholder="Enter Notes Description"
                              value={item.describe || ""}
                              onChange={(e) => {
                                const updated = [...notesDetails];
                                updated[index].describe = e.target.value || "";
                                setNotesDetails(updated);
                              }}
                              className="form-control"
                              style={{ flex: 3, resize: "vertical" }}
                              rows={4}
                            />
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const updated = notesDetails.map((n, i) =>
                                  i === index
                                    ? { ...n, file: e.target.files[0] }
                                    : n
                                );
                                setNotesDetails(updated);
                              }}
                            />
                            {item.preview && (
                              <img
                                src={item.preview}
                                alt="Note Preview"
                                style={{
                                  width: "100px",
                                  height: "80px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                            <div>
                              {notesDetails.length > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() => {
                                    setNotesDetails(
                                      notesDetails.filter((_, i) => i !== index)
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-outline-primary me-1 mb-2"
                          onClick={() => {
                            setNotesDetails([
                              ...notesDetails,
                              { id: Date.now(), describe: "", file: null },
                            ]);
                          }}
                        >
                          Add more
                        </button>
                      </>
                    )}

                    {activeTab === "pdf" && (
                      <>
                        <label className="pb-2">
                          <strong>Add Pdf Details:</strong>
                        </label>
                        {pdfDetails.map((item, index) => (
                          <div
                            key={item.id}
                            className="d-flex align-items-center mb-2"
                            style={{ gap: "8px" }}
                          >
                            <textarea
                              placeholder="Enter PDF Description"
                              value={item.describe}
                              onChange={(e) => {
                                const updated = [...pdfDetails];
                                updated[index].describe = e.target.value || "";
                                setPdfDetails(updated);
                              }}
                              className="form-control"
                              style={{ flex: 3, resize: "vertical" }}
                              rows={4}
                            />
                            <input
                              type="file"
                              accept="application/pdf"
                              onChange={(e) => {
                                const updated = [...pdfDetails];
                                updated[index].file = e.target.files[0];
                                setPdfDetails(updated);
                              }}
                            />
                            <div>
                              {pdfDetails.length > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() => {
                                    setPdfDetails(
                                      pdfDetails.filter((_, i) => i !== index)
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-outline-primary me-1 mb-2"
                          onClick={() => {
                            setPdfDetails([
                              ...pdfDetails,
                              { id: Date.now(), describe: "", file: null },
                            ]);
                          }}
                        >
                          Add More
                        </button>
                      </>
                    )}

                    {activeTab === "videos" && (
                      <>
                        <label className="pb-2">
                          <strong>Add Video Details:</strong>
                        </label>

                        {videoDetails.map((item, index) => (
                          <div
                            key={item.id}
                            className="d-flex align-items-center mb-2"
                            style={{ gap: "8px" }}
                          >
                            {/* Description (same as PDF) */}
                            <textarea
                              placeholder="Enter Video Description"
                              value={item.text}
                              onChange={(e) => {
                                const updated = [...videoDetails];
                                updated[index].text = e.target.value || "";
                                setVideoDetails(updated);
                              }}
                              className="form-control"
                              style={{ flex: 3, resize: "vertical" }}
                              rows={4}
                            />
                            {/* YouTube Checkbox */}
                            <div className="form-check mb-3">
                              <input
                                type="checkbox"
                                checked={item.is_youtube === 1}
                                onChange={(e) => {
                                  const updated = [...videoDetails];
                                  updated[index].is_youtube = e.target.checked
                                    ? 1
                                    : 0;
                                  updated[index].file = null;
                                  updated[index].youtube_url = "";
                                  setVideoDetails(updated);
                                }}
                              />

                              <label
                                className="form-check-label"
                                htmlFor="youtubeCheck"
                              >
                                Is YouTube Video?
                              </label>
                            </div>
                            {/* YouTube URL or File (same column position as PDF file) */}
                            {item.is_youtube ? (
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter YouTube URL"
                                value={item.youtube_url}
                                onChange={(e) => {
                                  const updated = [...videoDetails];
                                  updated[index].youtube_url =
                                    e.target.value || "";
                                  setVideoDetails(updated);
                                }}
                                style={{ flex: 2 }}
                                required
                              />
                            ) : (
                              <input
                                type="file"
                                accept="video/*"
                                onChange={(e) => {
                                  const updated = [...videoDetails];
                                  updated[index].file = e.target.files[0];
                                  setVideoDetails(updated);
                                }}
                                style={{ flex: 2 }}
                                required
                              />
                            )}

                            {/* Buttons (same as PDF) */}
                            <div>
                              {videoDetails.length > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() =>
                                    setVideoDetails(
                                      videoDetails.filter((_, i) => i !== index)
                                    )
                                  }
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-outline-primary me-1 mb-2"
                          onClick={() =>
                            setVideoDetails([
                              ...videoDetails,
                              {
                                id: Date.now(),
                                describe: "",
                                file: null,
                                youtube_url: "",
                              },
                            ])
                          }
                        >
                          Add More
                        </button>
                      </>
                    )}
                  </div>
                </>
              )}

              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentCreate;
